"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: "4px",
    height: "16px",
    viewBox: "0 0 4 16"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1187.000000, -186.000000)",
    fill: props.fill
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1176.000000, 169.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11,19 C11,20.1045695 11.8954305,21 13,21 C14.1045695,21 15,20.1045695 15,19 C15,17.8954305 14.1045695,17 13,17 C11.8954305,17 11,17.8954305 11,19 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11,25 C11,26.1045695 11.8954305,27 13,27 C14.1045695,27 15,26.1045695 15,25 C15,23.8954305 14.1045695,23 13,23 C11.8954305,23 11,23.8954305 11,25 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11,31 C11,32.1045695 11.8954305,33 13,33 C14.1045695,33 15,32.1045695 15,31 C15,29.8954305 14.1045695,29 13,29 C11.8954305,29 11,29.8954305 11,31 Z"
  })))));
};

exports["default"] = _default;